import { css } from '@emotion/react'
import type { ReactNode } from 'react'
import {
  Column,
  type ColumnSizeType,
  FlexContainer,
  type FlexContainerProps,
  Grid,
  Row,
} from '../../index'

type TemplateSize = 'large' | 'medium' | 'small'

type SizeMap = Record<
  'xl' | 'lg' | 'md' | 'sm',
  {
    [size in TemplateSize]: ColumnSizeType
  }
>

const sizeMap: SizeMap = {
  xl: { large: 8, medium: 6, small: 4 },
  lg: { large: 10, medium: 8, small: 6 },
  md: { large: 12, medium: 8, small: 8 },
  sm: { large: 12, medium: 12, small: 12 },
}

export interface CenteredLayoutProps {
  children: ReactNode
  className?: string
  contentAlign?: FlexContainerProps['justify']
  size: TemplateSize
  textAlign?: 'center' | 'start' | 'end'
}

const CenteredLayout = ({
  children,
  className,
  contentAlign = 'center',
  size,
  textAlign = 'start',
}: CenteredLayoutProps) => (
  <Grid
    className={className}
    css={css`
      height: 100%;
    `}
  >
    <Row
      css={css`
        height: 100%;
      `}
    >
      <Column size="equal" />
      <Column
        css={css`
          height: 100%;
        `}
        lg={sizeMap.lg[size]}
        md={sizeMap.md[size]}
        sm={sizeMap.sm[size]}
        xl={sizeMap.xl[size]}
      >
        <FlexContainer
          align="center"
          css={css`
            height: 100%;
            text-align: ${textAlign};
          `}
          direction="column"
          justify={contentAlign}
        >
          {children}
        </FlexContainer>
      </Column>
      <Column size="equal" />
    </Row>
  </Grid>
)

export default CenteredLayout
